export default __webpack_public_path__ + "static/Products_Placeholder_2.0@2x-48c1a63244786a33e84e278df4daaa6a.jpg";